import { DoneAll } from "@mui/icons-material";
import { Card, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function BenefitCard({ title, description, icon, padding = "10%" }) {
  return (
    <Card sx={{ height: "100%" }}>
      <SoftBox
        p={3}
        height="100%"
        bgColor={"transparent"}
        variant="gradient"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Grid container spacing={3}>
          <Grid item xs={4} md={4} style={{ textAlign: "center", paddingTop: padding }}>
            {icon}
          </Grid>
          <Grid item xs={8} md={8}>
            <SoftBox mt={1} lineHeight={1}>
              <SoftTypography
                variant="body2"
                color="text"
                textTransform="capitalize"
                fontWeight="medium"
              >
                {title}
              </SoftTypography>
              <SoftTypography variant="caption" color="text">
                {description}
              </SoftTypography>
            </SoftBox>
            <Grid />
          </Grid>
        </Grid>
      </SoftBox>
    </Card>
  );
}
export default BenefitCard;
